export default __webpack_public_path__ + "68307dbaf24a3da4d89532719d13a3ae.png";